const residencyDistrict = {

  Alameda: [
    "Alameda Unified",
    "Albany City Unified",
    "Amador Valley Joint Union High",
    "Berkeley Unified",
    "California School for the Deaf-Fremont (State Special Schl)",
    "Castro Valley Unified",
    "Dublin Unified",
    "East Bay Regional Occupational Agency (ROP)",
    "Eden Area ROP",
    "Emery Unified",
    "Fremont Unified",
    "Hayward Unified",
    "Hayward-Newhaven",
    "Livermore Valley Joint Unified",
    "Mission Valley ROC/P",
    "Mountain House Elementary",
    "Murray Elementary",
    "New Haven Unified",
    "Newark Unified",
    "Oakland Unified",
    "Peralta Community College",
    "Piedmont City Unified",
    "Pleasanton Joint Elementary",
    "Pleasanton Unified",
    "San Leandro Unified",
    "San Lorenzo Unified",
    "SBE - KIPP Summit Academy",
    "SBE - Latitude 37.8 High",
    "SBE - Leadership Public Schools - Hayward",
    "SBE - Livermore Valley Charter Preparatory High",
    "SBE - Livermore Valley Charter",
    "State Board of Education Charter",
    "Sunol Glen Elementary",
    "Sunol Glen Unified",
    "Tri-Valley ROP",
  ],
  Alpine: ["Alpine County Office of Education", "Alpine County Unified"],
  Amador: [
    "Amador County Office of Education",
    "Amador County ROP",
    "Amador County Unified",
    "CEA Amador Co",
    "Ione Unified",
    "Jackson Unified",
    "Oro Madre Unified",
    "Pine Grove Youth Conservation",
    "Preston School of Industry",
  ],
  Butte: [
    "Bangor Union Elementary",
    "Biggs Unified",
    "Butte County Office of Education",
    "Butte County ROP",
    "Chico Unified",
    "Durham Unified",
    "Feather Falls Union Elementary",
    "Golden Feather Union Elementary",
    "Gridley Unified",
    "Gridley Union Elementary",
    "Gridley Union High",
    "Manzanita Elementary",
    "Oroville City Elementary",
    "Oroville Union High",
    "Palermo Union Elementary",
    "Paradise Unified",
    "Pioneer Union Elementary",
    "Thermalito Union Elementary",
  ],
  Calaveras: [
    "Bret Harte Union High",
    "Calaveras County Office of Education",
    "Calaveras County ROP",
    "Calaveras Unified",
    "Fricot Ranch School for Boys",
    "Mark Twain Union Elementary",
    "Vallecito Union",
  ],
  Colusa: [
    "Colusa County Office of Education",
    "Colusa Unified",
    "Maxwell Unified",
    "Pierce Joint Unified",
    "Williams Unified",
  ],
  "Contra Costa": [
    "Acalanes Union High",
    "Antioch Unified",
    "Brentwood Union",
    "Byron Union Elementary",
    "Canyon Elementary",
    "Contra Costa County Office of Education",
    "Contra Costa County ROP",
    "John Swett Unified",
    "Knightsen Elementary",
    "Lafayette Elementary",
    "Liberty Union High",
    "Martinez Unified",
    "Moraga Elementary",
    "Mt. Diablo Unified",
    "Oakley Union Elementary",
    "Orinda Union",
    "Pittsburg Unified",
    "San Ramon Valley Unified",
    "SBE - John Henry High",
    "SBE - Rocketship Futuro Academy",
    "SBE - Synergy",
    "Walnut Creek Elementary",
    "West Contra Costa Unified",
  ],
  "Del Norte": [
    "Del Norte County Office of Education",
    "Del Norte County ROP",
    "Del Norte County Unified",
  ],
  "El Dorado": [
    "Black Oak Mine Unified",
    "Buckeye Union Elementary",
    "Camino Union Elementary",
    "Central Sierra ROP",
    "El Dorado County Office of Education",
    "El Dorado Union High",
    "Georgetown Divide Union Elemen",
    "Gold Oak Union Elementary",
    "Gold Trail Union Elementary",
    "Indian Diggings Elementary",
    "Lake Tahoe Community College",
    "Lake Tahoe Unified",
    "Latrobe",
    "Mother Lode Union Elementary",
    "Northside Union Elementary",
    "Pioneer Union",
    "Placerville Union Elementary",
    "Pollock Pines Elementary",
    "Rescue Union Elementary",
    "SBC - Aspire Public Schools",
    "SBC - Pacific Technology",
    "Silver Fork Elementary",
  ],

  Fresno: [
    "Alvina Elementary",
    "American Union Elementary",
    "Auberry Union Elementary",
    "Big Creek Elementary",
    "Biola-Pershing Union Elementary",
    "Burrel Union Elementary",
    "Cantua Elementary",
    "Caruthers Unified",
    "Caruthers Union Elementary",
    "Caruthers Union High",
    "Central Unified",
    "Central Union High",
    "Chawanakee Elementary",
    "Clay Joint Elementary",
    "Clovis Unified",
    "Coalinga-Huron Unified",
    "Firebaugh Joint Elementary",
    "Firebaugh-Las Deltas Unified",
    "Fowler Unified",
    "Fresno County Office of Education",
    "Fresno ROP",
    "Fresno Unified",
    "Friant Union Elementary",
    "Golden Hills Elementary",
    "Golden Plains Unified",
    "Helm Elementary",
    "Herndon Elementary",
    "Houghton-Kearney Union Elementary",
    "Kerman Unified",
    "Kerman Union High",
    "Kerman-Floyd Union Elementary",
    "Kings Canyon Joint Unified",
    "Kingsburg Elementary Charter",
    "Kingsburg Joint Union High",
    "Las Deltas Elementary",
    "Laton Joint Unified",
    "Madison Elementary",
    "McKinley-Roosevelt Union Elementary",
    "Mendota Unified",
    "Mendota Union Elementary",
    "Monroe Elementary",
    "Orange Center",
    "Oro Loma Elementary",
    "Pacific Union Elementary",
    "Parlier Unified",
    "Pine Ridge Elementary",
    "Raisin City Elementary",
    "Riverdale Joint Unified",
    "Riverdale Joint Union Elementary",
    "Riverdale Joint Union High",
    "San Joaquin Elementary",
    "Sanger Unified",
    "Selma Unified",
    "Sierra Joint Union High",
    "Sierra Unified",
    "Sierra Union Elementary",
    "Sun Empire Union Elementary",
    "Teague Elementary",
    "Tranquillity Elementary",
    "Tranquillity Union High",
    "Valley ROP",
    "Washington Colony Elementary",
    "Washington Unified",
    "Washington Union High",
    "West Fresno Elementary",
    "West Park Elementary",
    "Westside Elementary",
  ],
  Glenn: [
    "Capay Joint Union Elementary",
    "Glenn County Office of Education",
    "Glenn County ROP",
    "Hamilton Unified",
    "Hamilton Union Elementary",
    "Hamilton Union High",
    "Lake Elementary",
    "Orland Joint Unified",
    "Orland Joint Union Elementary",
    "Orland Joint Union High",
    "Plaza Elementary",
    "Princeton Joint Unified",
    "Stony Creek Joint Unified",
    "Willows Unified",
  ],
  Humboldt: [
    "Arcata Elementary",
    "Big Lagoon Union Elementary",
    "Blue Lake Union Elementary",
    "Bluff Prairie Elementary",
    "Bridgeville Elementary",
    "Cuddeback Union Elementary",
    "Cutten Elementary",
    "Eureka City Elementary",
    "Eureka City High",
    "Eureka City Schools",
    "Ferndale Elementary",
    "Ferndale Unified",
    "Ferndale Union High",
    "Fieldbrook Elementary",
    "Fortuna Elementary",
    "Fortuna Union Elementary",
    "Fortuna Union High",
    "Freshwater Elementary",
    "Garfield Elementary",
    "Green Point Elementary",
    "Grizzly Bluff Elementary",
    "Humboldt County Office of Education",
    "Humboldt County ROP",
    "Hydesville Elementary",
    "Jacoby Creek Elementary",
    "Klamath-Trinity Joint Unified",
    "Kneeland Elementary",
    "Loleta Union Elementary",
    "Maple Creek Elementary",
    "Mattole Unified",
    "Mattole Union Elementary",
    "McKinleyville Union Elementary",
    "Northern Humboldt Union High",
    "Orick Elementary",
    "Pacific Union Elementary",
    "Peninsula Union",
    "Rio Dell Elementary",
    "Rohnerville Elementary",
    "Scotia Union Elementary",
    "South Bay Union Elementary",
    "Southern Humboldt Joint Unified",
    "Trinidad Union Elementary",
  ],
  Imperial: [
    "Brawley Elementary",
    "Brawley Union High",
    "Calexico Unified",
    "Calipatria Unified",
    "Central Union High",
    "El Centro Elementary",
    "Heber Elementary",
    "Holtville Unified",
    "Imperial County Office of Education",
    "Imperial Unified",
    "Imperial Valley ROP",
    "Magnolia Union Elementary",
    "McCabe Union Elementary",
    "Meadows Union",
    "Mulberry Elementary",
    "San Pasqual Valley Unified",
    "Seeley Union Elementary",
    "Westmorland Union Elementary",
  ],
  Inyo: [
    "Big Pine Unified",
    "Bishop Joint Union High",
    "Bishop Unified",
    "Bishop Union Elementary",
    "Death Valley Unified",
    "Inyo County Office of Education",
    "Inyo County ROP",
    "Lone Pine Unified",
    "Owens Valley Unified",
    "Round Valley Joint Elementary",
  ],
  Kern: [
    "Arvin Union",
    "Bakersfield City",
    "Beardsley Elementary",
    "Belridge Elementary",
    "Blake Elementary",
    "Buttonwillow Union Elementary",
    "Caliente Union Elementary",
    "China Lake Joint Elementary",
    "Delano Joint Union High",
    "Delano Union Elementary",
    "Di Giorgio Elementary",
    "Edison Elementary",
    "El Tejon Unified",
    "El Tejon Union",
    "Elk Hills Elementary",
    "Fairfax Elementary",
    "Fruitvale Elementary",
    "General Shafter Elementary",
    "Greeley Elementary",
    "Greenfield Union",
    "Kern Community College",
    "Kern County Office of Education",
    "Kern County ROP",
    "Kern High ROC",
    "Kern High",
    "Kernville Union Elementary",
    "Lakeside Union",
    "Lamont Elementary",
    "Linns Valley-Poso Flat Union",
    "Lost Hills Union Elementary",
    "Maple Elementary",
    "Maricopa Unified",
    "McFarland Unified",
    "McKittrick Elementary",
    "Midway Elementary",
    "Mojave Unified",
    "Muroc Joint Unified",
    "Norris Elementary",
    "North Kern Vocational Training Center",
    "Panama Union Elementary",
    "Panama-Buena Vista Union",
    "Pond Union Elementary",
    "Rand Joint Elementary",
    "Richland Elementary",
    "Richland Union Elementary",
    "Rio Bravo Union Elementary",
    "Rio Bravo-Greeley Union Elementary",
    "Rosedale Union Elementary",
    "SBE - Ridgecrest Charter",
    "Semitropic Elementary",
    "Sierra Sands Unified",
    "South Fork Union",
    "Southern Kern Unified",
    "Standard Elementary",
    "Taft City",
    "Taft Union High",
    "Tehachapi Unified",
    "Vineland Elementary",
    "Wasco Union Elementary",
    "Wasco Union High",
    "West Kern Community College",
    "West Side ROP",
  ],
  Kings: [
    "Armona Union Elementary",
    "Central Union Elementary",
    "Corcoran Joint Unified",
    "Delta View Joint Union Elementary",
    "Hanford Elementary",
    "Hanford Joint Union High",
    "Island Union Elementary",
    "Kings County Office of Education",
    "Kings County ROP",
    "Kings River-Hardwick Union Elementary",
    "Kit Carson Union Elementary",
    "Lakeside Union Elementary",
    "Lemoore Union Elementary",
    "Lemoore Union High",
    "Pioneer Union Elementary",
    "Reef-Sunset Unified",
  ],
  Lake: [
    "Kelseyville Unified",
    "Konocti Conservation Camp",
    "Konocti Unified",
    "Lake County Office of Education",
    "Lake County ROP",
    "Lakeport Unified",
    "Lucerne Elementary",
    "Middletown Unified",
    "Upper Lake Unified",
    "Upper Lake Union Elementary",
    "Upper Lake Union High",
  ],
  Lassen: [
    "Big Valley Joint Unified",
    "Fort Sage Unified",
    "Herlong Elementary",
    "Janesville Union Elementary",
    "Johnstonville Elementary",
    "Lake Elementary",
    "Lassen County Office of Education",
    "Lassen ROP",
    "Lassen Union High",
    "Long Valley Elementary",
    "Ravendale-Termo Elementary",
    "Richmond Elementary",
    "SBE - Long Valley Charter",
    "Shaffer Union Elementary",
    "Susanville Elementary",
    "Westwood Unified",
  ],
  "Los Angeles": [
    "ABC Unified",
    "Acton-Agua Dulce Unified",
    "Alhambra City Elementary",
    "Alhambra City High",
    "Alhambra Unified",
    "Antelope Valley ROP",
    "Antelope Valley Union High",
    "Arcadia Unified",
    "Azusa Unified",
    "Baldwin Park Unified",
    "Bassett Unified",
    "Bellflower Unified",
    "Beverly Hills Unified",
    "Bonita Unified",
    "Burbank Unified",
    "California Advancing Pathways for Students in Los Angeles County ROC/P",
    "Castaic Union",
    "CEA Los Angeles Co",
    "Centinela Valley Union High",
    "Charter Oak Unified",
    "Claremont Unified",
    "Compton City Elementary",
    "Compton Unified ROP",
    "Compton Unified",
    "Compton Union High",
    "Covina-Valley Unified",
    "Culver City Unified",
    "Downey Unified",
    "Duarte Unified",
    "East Whittier City Elementary",
    "Eastside Union Elementary",
    "El Monte City",
    "El Monte Union High",
    "El Rancho Unified",
    "El Segundo Unified",
    "Enterprise City Elementary",
    "Fred C. Nelles School for Boys",
    "Garvey Elementary",
    "Glendale Community College",
    "Glendale Unified",
    "Glendora Unified",
    "Gorman Joint",
    "Hacienda la Puente Unified",
    "Hart ROP",
    "Hawthorne",
    "Hermosa Beach City Elementary",
    "Hudson Elementary",
    "Hughes-Elizabeth Lakes Union Elementary",
    "Inglewood Unified",
    "Keppel Union Elementary",
    "La Canada Unified",
    "La Puente Valley ROP",
    "Lancaster Elementary",
    "Lapuente Union High",
    "Las Virgenes Unified",
    "Lawndale Elementary",
    "Lennox",
    "Little Lake City Elementary",
    "Long Beach Unified ROP",
    "Long Beach Unified",
    "Los Angeles County Office of Education",
    "Los Angeles County ROP",
    "Los Angeles County Special Ed",
    "Los Angeles County Superintendent",
    "Los Angeles Unified ROCP",
    "Los Angeles Unified",
    "Los Nietos",
    "Lynwood Unified",
    "Manhattan Beach City Elementar",
    "Manhattan Beach Unified",
    "Monrovia Unified",
    "Montebello Unified",
    "Mountain View Elementary",
    "Newhall",
    "Norwalk-La Mirada Unified",
    "Palmdale Elementary",
    "Palos Verdes Peninsula Unified",
    "Paramount Unified",
    "Pasadena Area Community College",
    "Pasadena Unified",
    "Pomona Unified",
    "Redondo Beach City Elementary",
    "Redondo Beach Unified",
    "Rosemead Elementary",
    "Rowland Elementary",
    "Rowland Unified",
    "San Antonio ROP",
    "San Gabriel Elementary",
    "San Gabriel Unified",
    "San Gabriel Valley Regional Occupational Program",
    "San Marino Unified",
    "Santa Monica Community College",
    "Santa Monica-Malibu Unified",
    "Saugus Union",
    "SBE - Academia Avance Charter",
    "SBE - Academy of Culture and Technology (ACT)",
    "SBE - Anahuacalmecac International University Preparatory of North America",
    "SBE - Animo Inglewood Charter",
    "SBE - Barack Obama Charter",
    "SBE - Celerity Himalia",
    "SBE - Celerity Rolas",
    "SBE - Doris Topsy-Elvord Academy",
    "SBE - Eagle Collegiate Academy",
    "SBE - Ingenium Charter",
    "SBE - Lifeline Education Charter",
    "SBE - Los Angeles College Prep Academy",
    "SBE - New West Charter",
    "SBE - Prepa Tec Los Angeles High",
    "SBE - T.I.M.E. Community",
    "SBE - The School of Arts and Enterprise",
    "SBE - Today's Fresh Start Charter",
    "Soledad-Agua Dulce Union Eleme",
    "South Bay Union High",
    "South Pasadena Unified",
    "South Whittier Elementary",
    "Southeast ROP",
    "Southern California ROC",
    "Southern Reception Center Clin",
    "Sulphur Springs Union",
    "Temple City Unified",
    "Torrance Unified",
    "Tri-Cities ROP",
    "Valle Lindo Elementary",
    "Walnut Elem",
    "Walnut Valley Unified",
    "West Covina Unified",
    "Westside Union Elementary",
    "Whittier City",
    "Whittier Union High",
    "William S. Hart Union High",
    "Willowbrook Elem",
    "Wilsona Elementary",
    "Wiseburn Elementary",
    "Wiseburn Unified",
  ],
  Madera: [
    "Alview-Dairyland Union Elementary",
    "Bass Lake Joint Union Elementary",
    "Chawanakee Jt. Elementary",
    "Chawanakee Unified",
    "Chowchilla Elementary",
    "Chowchilla Union High",
    "Coarsegold Union Elementary",
    "Dairyland Union Elementary",
    "Golden Valley Unified",
    "Madera County Superintendent of Schools",
    "Madera Unified",
    "Minarets Jt. Union High",
    "North Fork Union Elementary",
    "Oakhurst Union Elementary",
    "Raymond-Knowles Union Elementary",
    "Sierra Jt. Union High",
    "Spring Valley Elementary",
    "Wasuma Union Elementary",
    "Yosemite Joint Union High",
    "Yosemite Unified",
  ],
  Marin: [
    "Bolinas-Stinson Union",
    "Fairfax Elementary",
    "Kentfield Elementary",
    "Laguna Joint Elementary",
    "Lagunitas Elementary",
    "Larkspur-Corte Madera",
    "Lincoln Elementary",
    "Marin Community College",
    "Marin County Office of Education",
    "Marin County ROP",
    "Mill Valley Elementary",
    "Miller Creek Elementary",
    "Nicasio",
    "Novato Unified",
    "Reed Union Elementary",
    "Ross Elementary",
    "Ross Valley Elementary",
    "San Anselmo Elementary",
    "San Rafael City Elementary",
    "San Rafael City High",
    "Sausalito Marin City",
    "SBE - Ross Valley Elementary",
    "Shoreline Unified",
    "Tamalpais Union High",
    "Union Joint Elementary",
  ],
  Mariposa: [
    "CEA Mariposa Co",
    "Mariposa County Office of Education",
    "Mariposa County Unified",
    "Mt. Bullion Youth Conservation",
  ],
  Mendocino: [
    "Anderson Valley Unified",
    "Arena Union Elementary",
    "Fort Bragg Unified",
    "Laytonville Unified",
    "Leggett Valley Unified",
    "Manchester Union Elementary",
    "Mendocino County Office of Education",
    "Mendocino County ROC/ROP",
    "Mendocino Unified",
    "Point Arena Joint Union High",
    "Potter Valley Community Unified",
    "Round Valley Unified",
    "Ukiah Unified",
    "Willits Unified",
  ],
  Merced: [
    "Atwater Elementary",
    "Ballico-Cressey Elementary",
    "Delhi Elementary",
    "Delhi Unified",
    "Dos Palos Joint Union Elementary",
    "Dos Palos Joint Union High",
    "Dos Palos Oro Loma Joint Unified",
    "El Nido Elementary",
    "Gustine Unified",
    "Hilmar Unified",
    "Hopeton Elementary",
    "Le Grand Union Elementary",
    "Le Grand Union High",
    "Livingston Union",
    "Los Banos Unified",
    "McSwain Union Elementary",
    "Merced City Elementary",
    "Merced County Office of Education",
    "Merced County ROP",
    "Merced River Union Elementary",
    "Merced Union High",
    "Newman-Gustine Jt. Unified",
    "Plainsburg Union Elementary",
    "Planada Elementary",
    "Snelling-Merced Falls Union Elementary",
    "Washington Elementary",
    "Weaver Union",
    "Winton",
  ],
  Modoc: [
    "Modoc County Office of Education",
    "Modoc County ROP",
    "Modoc Joint Unified",
    "Modoc-Tulelake Jt. Unified",
    "Surprise Valley Joint Unified",
    "Tulelake Basin Joint Unified",
  ],
  Mono: [
    "Antelope Union Elementary",
    "Benton Elementary",
    "Bridgeport Elementary",
    "Eastern Sierra Unified",
    "Lee Vining Union Elementary",
    "Mammoth Elementary",
    "Mammoth Unified",
    "Mono County High",
    "Mono County Office of Education",
    "Mono County ROC/P",
  ],
  Monterey: [
    "Alisal Union",
    "Big Sur Unified",
    "Bradley Union Elementary",
    "Carmel Unified",
    "Chualar Union",
    "Gonzales Unified",
    "Gonzales Union Elementary",
    "Gonzales Union High",
    "Graves Elementary",
    "Greenfield Union Elementary",
    "King City Union",
    "Lagunita Elementary",
    "Mission Trails ROP",
    "Mission Union Elementary",
    "Monterey County Office of Education",
    "Monterey Peninsula Unified",
    "North Monterey County Unified",
    "Pacific Elementary",
    "Pacific Grove Unified",
    "Salinas City Elementary",
    "Salinas Union High",
    "San Antonio Union Elementary",
    "San Ardo Union Elementary",
    "San Lucas Union Elementary",
    "Santa Rita Union Elementary",
    "Soledad Unified",
    "Soledad Union Elementary",
    "South Monterey County Joint Union High",
    "Spreckels Union Elementary",
    "Washington Union Elementary",
  ],
  Napa: [
    "Calistoga Joint Unified",
    "Howell Mountain Elementary",
    "Napa County Office of Education",
    "Napa County ROP",
    "Napa Valley Community College",
    "Napa Valley Unified",
    "Pope Valley Union Elementary",
    "Saint Helena Unified",
  ],
  Nevada: [
    "CEA Nevada Co",
    "Cherokee Elementary",
    "Chicago Park Elementary",
    "Clear Creek Elementary",
    "Grass Valley Elementary",
    "Nevada City Elementary",
    "Nevada County Office of Education",
    "Nevada Joint Union High",
    "North San Juan Elementary",
    "Penn Valley Union Elementary",
    "Pleasant Ridge Union Elementary",
    "Pleasant Valley Elementary",
    "Ready Springs Union Elementary",
    "San Juan Ridge Union Elementary",
    "Twin Ridges Elementary",
    "Union Hill Elementary",
    "Washington Ridge Youth Conserv",
  ],

  Orange: [
    "Anaheim Elementary",
    "Anaheim Union High",
    "Brea-Olinda Unified",
    "Buena Park Elementary",
    "Capistrano Unified",
    "Central Orange County CTE Partnership (CTEp)",
    "Centralia Elementary",
    "Coastline ROP",
    "College and Career Advantage",
    "Cypress Elementary",
    "Fountain Valley Elementary",
    "Fullerton Elementary",
    "Fullerton Joint Union High",
    "Garden Grove Unified",
    "Huntington Beach City Elementary",
    "Huntington Beach Union High",
    "Irvine Unified",
    "La Habra City Elementary",
    "Laguna Beach Unified",
    "Los Alamitos Unified",
    "Lowell Joint",
    "Magnolia Elementary",
    "Newport-Mesa Unified",
    "North Orange County Community College",
    "North Orange County ROP-Adult",
    "Ocean View",
    "Orange County Department of Education",
    "Orange Unified",
    "Placentia-Yorba Linda Unified",
    "Saddleback Valley Unified",
    "San Joaquin Elementary",
    "Santa Ana Unified",
    "Savanna Elementary",
    "SBE - Magnolia Science Academy Santa Ana",
    "Seal Beach Elementary",
    "Trabuco Elementary",
    "Tustin Unified",
    "Tustin Union High",
    "Westminster",
    "Yorba Linda",
  ],

  Placer: [
    "Ackerman Charter",
    "Alta-Dutch Flat Union Elementary",
    "Auburn Union Elementary",
    "Colfax Elementary",
    "Dry Creek Joint Elementary",
    "Emigrant Gap Elementary",
    "Eureka Union",
    "Foresthill Union Elementary",
    "Forty-Niner ROP",
    "Loomis Union Elementary",
    "Newcastle Elementary",
    "Ophir Elementary",
    "Penryn Elementary",
    "Placer County Office of Education",
    "Placer Hills Union Elementary",
    "Placer Union High",
    "Rocklin Elementary",
    "Rocklin Unified",
    "Roseville City Elementary",
    "Roseville Joint Union High",
    "SBE - Western Sierra Collegiate Academy",
    "Tahoe-Truckee Unified",
    "Western Placer Unified",
  ],
  Plumas: [
    "Plumas County Office of Education",
    "Plumas County ROP",
    "Plumas Unified",
  ],
  Riverside: [
    "Alvord Unified",
    "Banning Unified",
    "Beaumont Unified",
    "Calif Rehab Center (Corona-Nor",
    "California School for the Deaf-Riverside (State Special Schl)",
    "Coachella Elementary",
    "Coachella Valley Jt. Union High",
    "Coachella Valley Unified",
    "Corona-Norco Unified",
    "Desert Center Unified",
    "Desert Sands Unified",
    "Elsinore Union High",
    "Hemet Unified",
    "Jurupa Unified",
    "Lake Elsinore Unified",
    "Lake Elsinore Union",
    "Mecca Elementary",
    "Menifee Union",
    "Moreno Valley Unified",
    "Murrieta Elementary",
    "Murrieta Valley Unified",
    "Nuview Union",
    "Oasis Joint Elementary",
    "Palm Springs Unified",
    "Palo Verde Unified",
    "Perris Elementary",
    "Perris Union High",
    "Riverside County Office Of Education ROP",
    "Riverside County Office of Education",
    "Riverside Unified",
    "Romoland Elementary",
    "San Jacinto Unified",
    "SBE - Baypoint Preparatory Academy",
    "Temecula Union Elementary",
    "Temecula Valley Unified",
    "Thermal Union Elementary",
    "Val Verde Elementary",
    "Val Verde Unified",
  ],
  Sacramento: [
    "Arcohe Union Elementary",
    "California Education Authority (CEA) Headquarters",
    "Center Joint Elementary",
    "Center Joint Unified",
    "Del Paso Heights Elementary",
    "Elk Grove Unified",
    "Elverta Joint Elementary",
    "Folsom-Cordova Unified",
    "Galt Joint Union Elementary",
    "Galt Joint Union High",
    "Grant Joint Union High",
    "Los Rios Community College",
    "Marconi Technical Center (ROP/C)",
    "Natomas Unified",
    "Natomas Union Elementary",
    "North Sacramento Elementary",
    "Northern Reception Center Clin",
    "Rio Linda Union Elementary",
    "River Delta Joint Unified",
    "Robla Elementary",
    "Sacramento City Unified",
    "Sacramento County Office of Education",
    "Sacramento County ROP",
    "San Juan Unified",
    "SBE - Paramount Collegiate Academy",
    "Twin Rivers Unified",
  ],
  "San Benito": [
    "Aromas - San Juan Unified",
    "Bitterwater-Tully Elementary",
    "Cienega Union Elementary",
    "Hollister",
    "Jefferson Elementary",
    "New Idria Elementary",
    "North County Joint Union Elementary",
    "Olympia Elementary",
    "Panoche Elementary",
    "San Benito County Office of Education",
    "San Benito High",
    "San Juan Union Elementary",
    "Southside Elementary",
    "Tres Pinos Union Elementary",
    "Willow Grove Union Elementary",
  ],
  "San Bernardino": [
    "Adelanto Elementary",
    "Alta Loma Elementary",
    "Apple Valley Elementary",
    "Apple Valley Unified",
    "Baker Valley Unified",
    "Baldy View ROP",
    "Barstow Unified",
    "Bear Valley Unified",
    "Calif Institution for Women",
    "CEA San Bernardino Co",
    "Central Elementary",
    "Chaffey Joint Union High",
    "Chino Valley Unified",
    "Colton Joint Unified",
    "Colton-Redlands-Yucaipa ROP",
    "Cucamonga Elementary",
    "Etiwanda Elementary",
    "Fontana Unified",
    "Guasti Elementary",
    "Helendale Elementary",
    "Hesperia Elementary",
    "Hesperia Unified",
    "Los Flores Elementary",
    "Lucerne Valley Unified",
    "Lucerne Valley Union Elementary",
    "Morongo Unified",
    "Mountain View Elementary",
    "Mt. Baldy Joint Elementary",
    "Needles Unified",
    "Oak Glen Youth Conservation Ca",
    "Ontario-Montclair",
    "Oro Grande",
    "Phelan Elementary",
    "Redlands Unified",
    "Rialto Unified",
    "Rim of the World Unified",
    "San Bernardino City Unified",
    "San Bernardino County Office of Education",
    "San Bernardino County ROP",
    "SBE - Nova Meridian Academy",
    "Silver Valley Unified",
    "Snowline Joint Unified",
    "Trona Joint Unified",
    "Upland Elementary",
    "Upland Unified",
    "Victor Elementary",
    "Victor Valley Community College",
    "Victor Valley Union High",
    "Wrightwood Joint Elementary",
    "Youth Training School At Chino",
    "Yucaipa-Calimesa Joint Unified",
  ],
  "San Diego": [
    "Alpine Union Elementary",
    "Bonsall Unified",
    "Bonsall Union Elementary",
    "Borrego Springs Unified",
    "Cajon Valley Union",
    "Cardiff Elementary",
    "Carlsbad Unified",
    "Chula Vista Elementary",
    "Coronado Unified",
    "Dehesa Elementary",
    "Del Mar Union Elementary",
    "Encinitas Union Elementary",
    "Escondido Union High",
    "Escondido Union",
    "Fallbrook Union Elementary",
    "Fallbrook Union High",
    "Grossmont Union High",
    "Jamul-Dulzura Union Elementary",
    "Julian Union Elementary",
    "Julian Union High",
    "La Mesa-Spring Valley",
    "Lakeside Union Elementary",
    "Lemon Grove",
    "Mountain Empire Unified",
    "National Elementary",
    "Oceanside Unified",
    "Pauma Elementary",
    "Poway Unified",
    "Ramona City Unified",
    "Rancho Santa Fe Elementary",
    "Rich-Mar Union Elementary",
    "San Diego Community College",
    "San Diego County Office of Education",
    "San Diego County ROP",
    "San Diego Unified",
    "San Dieguito Union High",
    "San Marcos Unified",
    "San Pasqual Union Elementary",
    "San Ysidro Elementary",
    "Santee",
    "SBC - High Tech High",
    "SBE - Altus Schools East County",
    "SBE - Altus Schools South Bay",
    "SBE - Audeo Charter II",
    "SBE - Baypoint Preparatory Academy San Diego",
    "SBE - College Preparatory Middle",
    "SBE - Thrive Public",
    "SBE - Vista Springs Charter",
    "Solana Beach Elementary",
    "South Bay Union",
    "Spencer Valley Elementary",
    "Sweetwater Union High",
    "Vallecitos Elementary",
    "Valley Center Union Elementary",
    "Valley Center-Pauma Unified",
    "Vista Unified",
    "Warner Unified",
    "Warner Union Elementary",
  ],
  "San Francisco": [
    "City College of San Francisco",
    "Community Center School (Youth)",
    "San Francisco County Office of Education",
    "San Francisco County ROP",
    "San Francisco Unified",
    "SBE - Edison Charter Academy",
    "SBE - KIPP Bayview Elementary",
    "SBE - Mary L. Booker Leadership Academy",
    "SBE - Mission Preparatory",
    "SBE - OnePurpose",
    "SBE - San Francisco Flex Academy",
    "SBE - The New School of San Francisco",
  ],
  "San Joaquin": [
    "Banta Elementary",
    "Banta Unified",
    "CEA San Joaquin Co",
    "Delta Island Union Elementary",
    "Deuel Vocational Institution",
    "Dewitt-Nelson Training Center",
    "Escalon Unified",
    "Holt Union Elementary",
    "Jefferson Elementary",
    "Karl Holton School for Boys",
    "Lammersville Elementary",
    "Lammersville Joint Unified",
    "Lincoln Unified",
    "Linden Unified",
    "Lodi Unified",
    "Manteca Unified",
    "N.A. Chaderjian School for Boys",
    "New Hope Elementary",
    "New Jerusalem Elementary",
    "Northern California Youth Cent",
    "O. H. Close School for Boys",
    "Oak View Union Elementary",
    "Rindge Elementary",
    "Ripon Unified",
    "San Joaquin County Office of Education",
    "San Joaquin County ROP",
    "Stockton Unified",
    "Tracy Elementary",
    "Tracy Joint Unified",
    "Tracy Joint Union High",
  ],
  "San Luis Obispo": [
    "Atascadero Unified",
    "Cambria Union Elementary",
    "Cayucos Elementary",
    "CEA San Luis Obispo Co",
    "Coast Unified",
    "Coast Union High",
    "Fairview Elementary",
    "Lucia Mar Unified",
    "Paso Robles Joint Unified",
    "Paso Robles Joint Union High",
    "Paso Robles Union Elementary",
    "Phillips Elementary",
    "Pleasant Valley Joint Union Elementary",
    "San Luis Coastal Unified",
    "San Luis Obispo County Office of Education",
    "San Miguel Joint Union",
    "Santa Lucia ROP",
    "Shandon Joint Unified",
    "Templeton Unified",
  ],
  "San Mateo": [
    "Bayshore Elementary",
    "Belmont-Redwood Shores Elementary",
    "Brisbane Elementary",
    "Burlingame Elementary",
    "Cabrillo Unified",
    "Hillsborough City Elementary",
    "Jefferson Elementary",
    "Jefferson Union High",
    "La Honda-Pescadero Unified",
    "Las Lomitas Elementary",
    "Menlo Park City Elementary",
    "Millbrae Elementary",
    "Pacifica",
    "Portola Valley Elementary",
    "Ravenswood City Elementary",
    "Redwood City Elementary",
    "San Bruno Park Elementary",
    "San Carlos Elementary",
    "San Mateo County Office of Education",
    "San Mateo County ROP",
    "San Mateo Union High",
    "San Mateo-Foster City",
    "SBE - Everest Public High",
    "SBE - High Tech High Bayshore",
    "Sequoia Union High",
    "South San Francisco Unified",
    "Woodside Elementary",
  ],
  "Santa Barbara": [
    "Ballard Elementary",
    "Blochman Union Elementary",
    "Buellton Union Elementary",
    "Carpinteria Unified",
    "Casmalia Elementary",
    "Cold Spring Elementary",
    "College Elementary",
    "Cuyama Joint Unified",
    "Cuyama Joint Union Elementary",
    "Goleta Union Elementary",
    "Guadalupe Union Elementary",
    "Hope Elementary",
    "Lompoc Unified",
    "Los Alamos Elementary",
    "Los Olivos Elementary",
    "Montecito Union Elementary",
    "Orcutt Union Elementary",
    "Santa Barbara County Office of Education",
    "Santa Barbara County ROP",
    "Santa Barbara Elementary",
    "Santa Barbara Secondary",
    "Santa Barbara Unified",
    "Santa Maria Elementary",
    "Santa Maria Joint Union High",
    "Santa Maria-Bonita",
    "Santa Ynez Valley Union High",
    "SBE - Olive Grove Charter - Buellton",
    "SBE - Olive Grove Charter - Lompoc",
    "SBE - Olive Grove Charter - Orcutt/Santa Maria",
    "SBE - Olive Grove Charter - Santa Barbara",
    "SBE - Olive Grove Charter",
    "Solvang Elementary",
    "Vista del Mar Union",
  ],
  "Santa Clara": [
    "Alum Rock Union Elementary",
    "Berryessa Union Elementary",
    "Cambrian",
    "Campbell Union High",
    "Campbell Union",
    "Cupertino Union",
    "East Side Union High",
    "Evergreen Elementary",
    "Franklin-McKinley Elementary",
    "Fremont Union High",
    "Gilroy Unified",
    "Lakeside Joint",
    "Loma Prieta Joint Union Elementary",
    "Los Altos Elementary",
    "Los Gatos Union Elementary",
    "Los Gatos-Saratoga Union High",
    "Luther Burbank",
    "Metro Education",
    "Milpitas Unified",
    "Montebello Elementary",
    "Moreland",
    "Morgan Hill Unified",
    "Mount Pleasant Elementary",
    "Mountain View Whisman",
    "Mountain View-Los Altos Union High",
    "North County Regional Occupational Center/Program (ROC/P)",
    "Oak Grove Elementary",
    "Orchard Elementary",
    "Palo Alto Unified",
    "San Jose Unified",
    "San Jose/Evergreen Community College",
    "Santa Clara County Office of Education",
    "Santa Clara County ROP",
    "Santa Clara Unified",
    "Saratoga Union Elementary",
    "SBE - KIPP Navigate College Prep",
    "SBE - Perseverance Preparatory",
    "SBE - Promise Academy",
    "SBE - Wei Yu International Charter",
    "Sunnyvale",
    "Union Elementary",
    "Whisman Elementary",
  ],
  "Santa Cruz": [
    "Bonny Doon Union Elementary",
    "CEA Santa Cruz Co",
    "Happy Valley Elementary",
    "Live Oak Elementary",
    "Mountain Elementary",
    "Pacific Elementary",
    "Pajaro Valley Unified",
    "San Lorenzo Valley Unified",
    "Santa Cruz City Elementary",
    "Santa Cruz City High",
    "Santa Cruz Co Cya Dist",
    "Santa Cruz County Office of Education",
    "Santa Cruz County ROP",
    "SBE - Watsonville Prep",
    "Scotts Valley Unified",
    "Scotts Valley Union Elementary",
    "Soquel Union Elementary",
  ],
  Shasta: [
    "Anderson Union High",
    "Bass Elementary",
    "Bella Vista Elementary",
    "Black Butte Union Elementary",
    "Buckeye Elementary",
    "Canyon Union Elementary",
    "Cascade Union Elementary",
    "Castle Rock Union Elementary",
    "Columbia Elementary",
    "Cottonwood Union Elementary",
    "Enterprise Elementary",
    "Fall River Joint Unified",
    "French Gulch-Whiskeytown Elementary",
    "Gateway Unified",
    "Grant Elementary",
    "Happy Valley Union Elementary",
    "Igo, Ono, Platina Union Elementary",
    "Indian Springs Elementary",
    "Junction Elementary",
    "Millville Elementary",
    "Mountain Union Elementary",
    "North Cow Creek Elementary",
    "Oak Run Elementary",
    "Pacheco Union Elementary",
    "Redding Elementary",
    "Shasta County Office of Education",
    "Shasta Lake Union Elementary",
    "Shasta Union Elementary",
    "Shasta Union High",
    "Shasta-Tehama-Trinity Joint Community College",
    "Shasta-Trinity ROP",
    "Whitmore Union Elementary",
  ],
  Sierra: [
    "Sierra County Office of Education",
    "Sierra-Plumas Joint Unified",
    "William (R) Rouse ROP",
  ],
  Siskiyou: [
    "Big Springs Union Elementary",
    "Bogus Elementary",
    "Butte Valley Unified",
    "Butteville Union Elementary",
    "Callahan-East Fork Union Eleme",
    "Delphic Elementary",
    "Dorris Elementary",
    "Dunsmuir Elementary",
    "Dunsmuir Joint Union High",
    "Etna Union Elementary",
    "Etna Union High",
    "Fall Creek Elementary",
    "Forks of Salmon Elementary",
    "Fort Jones Union Elementary",
    "Gazelle Union Elementary",
    "Grenada Elementary",
    "Happy Camp Union Elementary",
    "Hilt Elementary",
    "Hornbrook Elementary",
    "Junction Elementary",
    "Klamath River Union Elementary",
    "Little Shasta Elementary",
    "McCloud Union Elementary",
    "Montague Elementary",
    "Mt. Shasta Union Elementary",
    "Quartz Valley Elementary",
    "Sawyers Bar Elementary",
    "Scott Valley Unified",
    "Seiad Elementary",
    "Siskiyou County Office of Education",
    "Siskiyou County ROP",
    "Siskiyou ROP",
    "Siskiyou Union High",
    "Weed Union Elementary",
    "Willow Creek Elementary",
    "Yreka Union Elementary",
    "Yreka Union High",
  ],
  Solano: [
    "Benicia Unified",
    "Dixon Unified",
    "Fairfield-Suisun Unified",
    "SBE - Dixon Montessori Charter",
    "Solano County Office of Education",
    "Solano County ROP",
    "Travis Unified",
    "Vacaville Unified",
    "Vallejo City Unified",
  ],
  Sonoma: [
    "Alexander Valley Union Elementary",
    "Bellevue Union",
    "Bennett Valley Union Elementary",
    "Cinnabar Elementary",
    "Cloverdale Unified",
    "Cotati-Rohnert Park Elementary",
    "Cotati-Rohnert Park Unified",
    "Dunham Elementary",
    "Forestville Union Elementary",
    "Fort Ross Elementary",
    "Geyserville Unified",
    "Gravenstein Union Elementary",
    "Guerneville Elementary",
    "Harmony Union Elementary",
    "Healdsburg Unified",
    "Healdsburg Union Elementary",
    "Healdsburg Union High",
    "Horicon Elementary",
    "Kashia Elementary",
    "Kenwood",
    "Liberty Elementary",
    "Los Guilucos School for Girls",
    "Mark West Union Elementary",
    "Monte Rio Union Elementary",
    "Montgomery Elementary",
    "Oak Grove Union Elementary",
    "Old Adobe Union",
    "Petaluma City Elementary",
    "Petaluma Joint Union High",
    "Piner-Olivet Union Elementary",
    "Rincon Valley Union Elementary",
    "Roseland",
    "Santa Rosa Elementary",
    "Santa Rosa High",
    "SBE - River Montessori Elementary Charter",
    "Sebastopol Union Elementary",
    "Sonoma County Office of Education",
    "Sonoma County ROP",
    "Sonoma Valley Unified",
    "Twin Hills Union Elementary",
    "Two Rock Union",
    "Waugh Elementary",
    "West Side Union Elementary",
    "West Sonoma County Union High",
    "Wilmar Union Elementary",
    "Windsor Unified",
    "Windsor Union Elementary",
    "Wright Elementary",
  ],
  Stanislaus: [
    "Ceres Unified",
    "Chatom Union",
    "Denair Unified",
    "Empire Union Elementary",
    "Gratton Elementary",
    "Hart-Ransom Union Elementary",
    "Hickman Community Charter",
    "Hughson Unified",
    "Hughson Union Elementary",
    "Hughson Union High",
    "Keyes Union",
    "Knights Ferry Elementary",
    "La Grange Elementary",
    "Modesto City Elementary",
    "Modesto City High",
    "Newman-Crows Landing Unified",
    "Oakdale Joint Unified",
    "Oakdale Joint Union High",
    "Oakdale Union Elementary",
    "Paradise Elementary",
    "Patterson Joint Unified",
    "Riverbank Elementary",
    "Riverbank Unified",
    "Roberts Ferry Union Elementary",
    "Salida Union Elementary",
    "SBE - Aspire Vanguard College Preparatory Academy",
    "Shiloh Elementary",
    "Stanislaus County Office of Education",
    "Stanislaus Union Elementary",
    "Sylvan Union Elementary",
    "Turlock Joint Elementary",
    "Turlock Joint Union High",
    "Turlock Unified",
    "Valley Home Joint Elementary",
    "Waterford Elementary",
    "Waterford Unified",
    "Yosemite ROP",
  ],
  Sutter: [
    "Brittan Elementary",
    "Browns Elementary",
    "East Nicolaus Joint Union High",
    "Franklin Elementary",
    "Live Oak Unified",
    "Marcum-Illinois Union Elementary",
    "Meridian Elementary",
    "Nuestro Elementary",
    "Pleasant Grove Joint Union",
    "Sutter County Office of Education",
    "Sutter Union High",
    "Tri-County ROP",
    "Winship-Robbins",
    "Yuba City Unified",
  ],
  Tehama: [
    "Antelope Elementary",
    "Bend Elementary",
    "Corning Union Elementary",
    "Corning Union High",
    "Elkins Elementary",
    "Evergreen Union",
    "Flournoy Union Elementary",
    "Gerber Union Elementary",
    "Kirkwood Elementary",
    "Lassen View Union Elementary",
    "Los Molinos Unified",
    "Manton Joint Union Elementary",
    "Mineral Elementary",
    "Plum Valley Elementary",
    "Red Bluff Joint Union High",
    "Red Bluff Union Elementary",
    "Reeds Creek Elementary",
    "Richfield Elementary",
    "Tehama County Department of Education",
    "Tehama County ROP",
  ],
  Trinity: [
    "Burnt Ranch Elementary",
    "Coffee Creek Elementary",
    "Cox Bar Elementary",
    "Douglas City Elementary",
    "Hayfork Valley Union Elementary",
    "Hoaglin-Zenia Union Elementary",
    "Hyampom Elementary",
    "Junction City Elementary",
    "Lewiston Elementary",
    "Mad River Joint Elementary",
    "Mountain Valley Unified",
    "Southern Trinity Joint Unified",
    "Trinity Alps Unified",
    "Trinity Center Elementary",
    "Trinity County Office of Education",
    "Trinity Union High",
    "Weaverville Elementary",
  ],
  Tulare: [
    "Allensworth Elementary",
    "Alpaugh Unified",
    "Alta Vista Elementary",
    "Buena Vista Elementary",
    "Burton Elementary",
    "Citrus South Tule Elementary",
    "Columbine Elementary",
    "Cutler-Orosi Joint Unified",
    "Dinuba Elementary",
    "Dinuba Joint Union High",
    "Dinuba Unified",
    "Ducor Union Elementary",
    "Earlimart Elementary",
    "Exeter Unified",
    "Exeter Union Elementary",
    "Exeter Union High",
    "Farmersville Elementary",
    "Farmersville Unified",
    "Hope Elementary",
    "Hot Springs Elementary",
    "Kings River Union Elementary",
    "Liberty Elementary",
    "Lindsay Unified",
    "Monson-Sultana Joint Union Elementary",
    "Oak Valley Union Elementary",
    "Outside Creek Elementary",
    "Palo Verde Union Elementary",
    "Pixley Union Elementary",
    "Pleasant View Elementary",
    "Porterville Elementary",
    "Porterville Unified",
    "Porterville Union High",
    "Richgrove Elementary",
    "Rockford Elementary",
    "Saucelito Elementary",
    "Sequoia Union Elementary",
    "Springville Union Elementary",
    "Stone Corral Elementary",
    "Strathmore Union Elementary",
    "Strathmore Union High",
    "Sundale Union Elementary",
    "Sunnyside Union Elementary",
    "Terra Bella Union Elementary",
    "Three Rivers Union Elementary",
    "Tipton Elementary",
    "Traver Joint Elementary",
    "Tulare City",
    "Tulare County Office of Education",
    "Tulare County Organization for Vocational Education",
    "Tulare Joint Union High",
    "Visalia Unified",
    "Waukena Joint Union Elementary",
    "Woodlake Unified",
    "Woodlake Union Elementary",
    "Woodlake Union High",
    "Woodville Union Elementary",
  ],
  Tuolumne: [
    "Belleview Elementary",
    "Big Oak Flat-Groveland Unified",
    "Big Oak Flat-Groveland Union Elementary",
    "Chinese Camp Elementary",
    "Columbia Union",
    "Curtis Creek Elementary",
    "Jamestown Elementary",
    "Sierra Conservation Center",
    "Sonora Elementary",
    "Sonora Union High",
    "Soulsbyville Elementary",
    "Summerville Elementary",
    "Summerville Union High",
    "Tuolumne County Superintendent of Schools",
    "Twain Harte",
  ],
  Ventura: [
    "Briggs Elementary",
    "Conejo Valley Unified",
    "Fillmore Unified",
    "Hueneme Elementary",
    "Mesa Union Elementary",
    "Moorpark Memorial Union High",
    "Moorpark Unified",
    "Moorpark Union Elementary",
    "Mupu Elementary",
    "Oak Park Unified",
    "Ocean View",
    "Ojai Unified",
    "Oxnard Union High",
    "Oxnard",
    "Pleasant Valley",
    "Rio Elementary",
    "Santa Clara Elementary",
    "Santa Paula Elementary",
    "Santa Paula Unified",
    "Santa Paula Union High",
    "Simi Valley Unified",
    "Somis Union",
    "Valley Oaks Union Elementary",
    "Ventura County Office of Education",
    "Ventura County ROP",
    "Ventura School for Girls",
    "Ventura Unified",
  ],
  Yolo: [
    "Davis Joint Unified",
    "Esparto Unified",
    "SBE - California College, Career & Technical Education Center",
    "Washington Unified",
    "Winters Joint Unified",
    "Woodland Joint Unified",
    "Yolo County Office of Education",
    "Yolo County ROP",
  ],
  Yuba: [
    "Camptonville Elementary",
    "Marysville Joint Unified",
    "Plumas Lake Elementary",
    "Wheatland Union High",
    "Wheatland",
    "Yuba County Office of Education",
  ],
};

export default residencyDistrict;
